import React, { Fragment, useEffect, useRef, useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {
    Box,
    Button,
    colors,
    Container,
    CssBaseline,
    FormControlLabel,
    Hidden,
    makeStyles,
    Paper,
    Typography,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import {
    useStylesAutoPurch
    , useStylesUiElemment,
    useStylesSpDial,
    useStylesLbl,
    useStylesAutoSafe,
} from '../../../../St/Reports/UseStyle';
import AddIcon from "@material-ui/icons/Add";

import CircularProgress from "@material-ui/core/CircularProgress";
import {
    useStylesUp,
    useStylesHed,
    useStylesAuto,
    useStylesTF,
    useStylesTD,
    useStylesBA,
    SaleSwitch,
} from "../../../../St/comps/UseStyle";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import StopIcon from "@material-ui/icons/Stop";
import { Search, TableChartSharp, Update } from "@material-ui/icons";
import i18next from "i18next";

const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },
    itemW: {
        // display:'flex',
        width: "90%",
    },
    headerTitle: {
        // backgroundColor: colors.green[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
        fontWeight: "bold"
    },
    headerTitle2: {
        backgroundColor: colors.green[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
        direction: "rtl"
    },
    headerTitleP: {
        backgroundColor: colors.blue[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
        direction: "rtl"
    },
    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: colors.blue[50],
        borderColor: colors.blue[300],
    },
}));

export default function RestHeader(props) {
    const {
        AutoOptions,
        isPurches,
        setting,
        handleOpenCustomer,
        changAutoCustomers
        , optionsCustomers,
        changAutoSalesMen,
        valueSalesmen,
        changAutoCostcenter,
        valueCostcenter,
        idata,
        changAutoType,
        valueType,
        valueSafes,
        changAutoSafes,
        changAutoStock,
        valueStock,
        changAutoBank,
        valueBank,
        changSwitch,
        uiElement,
        switchState,
        lbl,
        claslbl,
        gets,
        onChangeSearch,
        handleFocus,
        onChangeData,
        rptParams,
        setShowPaid,
        exsub,
        handClickInvs,
        infoInv,
        changIdata,
        showPaid,
        clasCAB,
        changInvs,
        loading,
        toWhere,
        buttonClassnameSavetmp,
        SaleCheckbox,
        valueCustomers,
        maxShifts,
        isStock,
        isMake,
        inputRef,
        isHedden,
        getCustomerData,
        transForm,
        selectOrderType,
        orderData,
        changeOrderType,
        maxOrderNo,
        permistionInv,
        localCashe,
        getBarcodeMezan,
        getBarcodeMulti,
        isdata,
        barcodeadd,
        setRptParams,
        handleInputSearchCust,
        handleIconSearchCust,
        searchCustText,
        setOpenTawla,
        getCodeDiscount
    } = props;

    const { t } = useTranslation(["forms"]);

    const clasup = useStylesUp();
    const calsPurch = useStylesAutoPurch();
    const claslbls = useStylesLbl();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();

    let AutoItem = permistionInv?.AUTI == null ? true : permistionInv?.AUTI;

    const clasTD = useStylesTD();


    const getoptionlbl2 = (option) => {

        return `${option.name + '-' + option.id}`
    };

    const getoptionlbl = (option) => {

        return `${option.id == null ? "ابحث عن رقم الصنف" : option.id}`
    };

    const buffer = useRef("");
    const [queue, setQueue] = useState([]);
    const [proccessing, setProccessing] = useState(false);

    useEffect(() => {
        let AutoItem = permistionInv?.AUTI == null ? true : permistionInv?.AUTI;
        if (inputRef.current && AutoItem) {
            inputRef.current.focus();
        }
    }, [inputRef, permistionInv]);
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {

            e.preventDefault();
            const code = e.target.value.trim();
            if (code !== "") {
                setQueue(prev => [...prev, code]);
                buffer.current = "";
                // e.target.value="";
                if (inputRef.current) {
                    inputRef.current.value = "";
                }
            }
            e.target.value = "";

            // return;
        }

        if (e.key.length !== 1) return;
        buffer.current += e.key;

    };

    useEffect(() => {
        if (!proccessing && queue.length > 0) {
            proccessNext();
        }
    }, [queue, proccessing, rptParams, localCashe, permistionInv, isdata]);

    const proccessNext = async () => {

        if (queue.length === 0) return;
        setProccessing(true);
        const barcode = queue[0];
        console.log("the barcodesss is", localCashe);
        const isMezan = permistionInv?.USEMEZAN && (barcode.length === 13 || barcode.length === 18) &&
            (barcode.startsWith("99") || barcode.startsWith("21")) ? true : false;
        try {
            const newItem = localCashe.find((obj) => obj.item.barcode.toString() === barcode.toString());
            if (newItem && !isMezan) {

                let totValbef = 0.0;
                for (let m = 0; m < isdata.length; m++) {
                    if (newItem?.item?.curr == isdata[m].currency_from)
                        totValbef += (isdata[m].val1 * isdata[m].val);
                };
                let oldVal = Number(newItem.val) - totValbef;

                setRptParams({ ...rptParams, barcode: '', barcodeS: '', curr: {} });
                if (permistionInv.SIM == false &&
                    oldVal < 1 && newItem?.item?.ctype != 4 &&
                    (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
                    alert(
                        `
                الكمية المدخلة للصنف أكبر من رصيد المخزن
                الكمية الاجمالية المدخلة : ${Number(totValbef) + (parseFloat(1) * parseFloat(newItem.item?.perc))
                        }
                رصيد المخزن : ${valueSafes.name} = ${parseInt(newItem?.val)
                        }
                `
                    );
                } else {
                    await barcodeadd({ ...newItem?.item }, { ...newItem?.unit }, newItem.units, newItem.val);
                }
            } else {

                if (isMezan)
                    await getBarcodeMezan(barcode);
                else
                    await getBarcodeMulti(barcode);
            }
        } catch (e) { }
        setQueue(pref => pref.slice(1));
        setProccessing(false)
    };
    return (
        <div
        // className={classes.root}
        >
            <Typography
                component="div"
                className="notranslate"
                style={{ direction: i18next.language == "ar" ? "rtl" : "ltr", }}
            >
                <CssBaseline />
                <Container
                    component={Paper}
                    maxWidth={false}
                    style={{
                        padding: "10px",
                        paddingBottom: "0px",
                        borderBottomColor: isPurches ? "#008080" : isStock ? "#3f51b5" : isMake ? "#c74375" : colors.green[300],
                        borderBottomWidth: "1px",
                        borderBottomStyle: "solid",
                    }}
                >
                    <React.Fragment>
                        <Grid item xs={12} container spacing={1}>
                            {permistionInv?.REGNOCUST ?
                                (
                                    <Grid item lg={2} md={2} sm={3} xs={8} style={{ paddingBottom: "0.5rem" }}>
                                        <TextField fullWidth variant="outlined" size="small"
                                            id="refno"
                                            label={t("customer")}
                                            className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                            InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrSale }}
                                            type="text"
                                            name="customer_name"
                                            value={idata?.customer_name}
                                            onChange={changIdata("customer_name")}
                                        />
                                    </Grid>
                                ) : (
                                    <>
                                        <Grid
                                            item

                                            style={{
                                                paddingRight: "2px",
                                                color: isPurches ? colors.blue[500] : isStock ? colors.blue[500] : isMake ? colors.blue[500] : colors.green[50],
                                                textAlign: "-webkit-center",
                                            }}
                                        >
                                            <IconButton
                                                color="inherit"
                                                style={{
                                                    background: isPurches ? "#008080" : colors.green[500],
                                                    padding: "10px",
                                                    color: "#fff",
                                                }}
                                                aria-label="open drawer"
                                                onClick={handleOpenCustomer}
                                            >
                                                <AddIcon />
                                            </IconButton>
                                        </Grid>
                                        <Grid item lg={2} md={3} sm={3} xs={7} style={{ paddingBottom: "0.5rem" }}>

                                            <Autocomplete classes={clasAo}
                                                value={valueCustomers}
                                                // onInputChange={handleInputSearchCust}
                                                onInputChange={(event, newValue, reason) => {
                                                    if (reason === "input") handleInputSearchCust(event, newValue, reason);
                                                }}
                                                id="combo-box-demo"
                                                size="small"
                                                options={optionsCustomers}
                                                getOptionLabel={(option) =>
                                                    typeof option === "string" ? option : option.name
                                                }
                                                style={{ backgroundColor: isPurches ? colors.blue[50] : isStock ? colors.blue[50] : colors.green[50] }}
                                                // disabled={isHedden}
                                                disableClearable
                                                renderInput={(params) => (
                                                    <Box size="small" display={"flex"} textAlign={"center"}>
                                                        <TextField
                                                            {...params}
                                                            label={setting.cusType == 1 ? "العميل" : "المورد"}
                                                            variant="outlined"
                                                            fullWidth
                                                            size="small"
                                                            textAlign={"center"}
                                                            InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : isMake ? claslbls.clrBlackLblS : claslbls.clrSale }}
                                                        />
                                                        {searchCustText != "" &&
                                                            (
                                                                <IconButton size="small" onClick={handleIconSearchCust}>
                                                                    <Search />
                                                                </IconButton>
                                                            )}
                                                    </Box>
                                                )}
                                                onChange={(event, newValue) => {
                                                    changAutoCustomers(newValue);
                                                }}
                                            />
                                        </Grid>

                                        <Grid
                                            item

                                            style={{
                                                paddingRight: "2px",
                                                color: isPurches ? colors.blue[500] : isStock ? colors.blue[500] : colors.green[50],
                                                textAlign: "-webkit-center",
                                            }}
                                        >
                                            <IconButton
                                                color="inherit"
                                                style={{
                                                    background: "#fff",
                                                    padding: "5px",
                                                    color: isPurches ? "#008080" : isStock ? "#3f51b5" : colors.green[900],
                                                }}
                                                aria-label="open drawer"
                                                onClick={() => {
                                                    getCustomerData();
                                                }}
                                            >
                                                <Update />
                                            </IconButton>
                                        </Grid>
                                    </>)}
                            <Grid item lg={1} md={2} sm={2} xs={3}>
                                <Autocomplete
                                    classes={clasAo}
                                    value={valueSalesmen}
                                    onChange={(event, newValue) => {
                                        changAutoSalesMen(newValue);
                                    }}
                                    id="controllable-states-demo"
                                    size="small"
                                    options={gets.salesmen}
                                    getOptionLabel={(option) =>
                                        typeof option === "string" ? option : option.name
                                    }
                                    disableClearable
                                    renderInput={(params) => (
                                        <TextField
                                            id="valueSalesmen"
                                            {...params}
                                            label={transForm("delegate")}
                                            variant="outlined"
                                            size="small"
                                            InputProps={{ ...params.InputProps, readOnly: true }}
                                            InputLabelProps={{ className: claslbl.clor }}
                                        />
                                    )}
                                />
                            </Grid>

                            <Grid item lg={1} md={2} sm={2} xs={4}>
                                <Autocomplete
                                    classes={clasAo}
                                    value={valueCostcenter}
                                    onChange={(event, newValue) => {
                                        changAutoCostcenter(newValue);
                                    }}
                                    id="controllable-states-demo"
                                    size="small"
                                    options={gets.costcenters}
                                    getOptionLabel={(option) =>
                                        typeof option === "string" ? option : option.name
                                    }
                                    // style={{  }}
                                    disableClearable
                                    renderInput={(params) => (
                                        <TextField
                                            id="valueCostcenter"
                                            {...params}
                                            label={transForm("center")}
                                            variant="outlined"
                                            size="small"
                                            InputProps={{ ...params.InputProps, readOnly: true }}
                                            InputLabelProps={{ className: claslbl.clor }}
                                        />
                                    )}
                                />
                            </Grid>

                            <Grid item lg={1} md={2} sm={2} xs={4}>
                                <TextField
                                    type="text"
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    id="id"
                                    label={transForm("invoice-id")}
                                    className={clasTF.root}
                                    InputProps={{ className: clasTF.input, readOnly: true }}
                                    name="id"
                                    value={infoInv.id}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>

                            <Grid item lg={1} md={2} sm={2} xs={4}>
                                {
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        id="date"
                                        label={transForm("date")}
                                        className={clasTF.root}
                                        InputProps={{ className: clasTD.input }}
                                        type="date"
                                        format="YYYY-MM-DD"
                                        InputLabelProps={{ shrink: true }}
                                        name="date"
                                        value={idata.date}
                                        onChange={changIdata("date")}
                                    />
                                }
                            </Grid>

                            <Grid item lg={1} md={2} sm={2} xs={4}>
                                <TextField
                                    type="number"
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    id="refno"
                                    label={transForm("ref-no")}
                                    className={clasTF.root}
                                    InputProps={{ className: clasTF.input }}
                                    name="refno"
                                    value={idata.refno}
                                    onChange={changIdata("refno")}
                                />
                            </Grid>

                            <Grid item lg={1} md={2} sm={2} xs={3}>
                                <Autocomplete
                                    classes={clasAo}
                                    value={valueType}
                                    onChange={(event, newValue) => {
                                        changAutoType(newValue, true);
                                    }}
                                    id="controllable-states-demo"
                                    size="small"
                                    options={AutoOptions.types}
                                    getOptionLabel={(option) =>
                                        typeof option === "string" ? option : option.name
                                    }
                                    // style={{  }}
                                    autoComplete={false}
                                    disableClearable
                                    renderInput={(params) => (
                                        <TextField
                                            id="valueTypeF"
                                            {...params}
                                            label={transForm("invoice-type")}
                                            variant="outlined"
                                            size="small"
                                            InputProps={{ ...params.InputProps, readOnly: true }}
                                            InputLabelProps={{ className: claslbl.clor }}
                                        // InputLabelProps={{shrink: true}}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item lg={1} md={2} sm={2} xs={4}>
                                <Autocomplete
                                    classes={clasAo}
                                    value={valueSafes}
                                    onChange={(event, newValue) => {
                                        changAutoSafes(newValue);
                                    }}
                                    id="controllable-states-demo"
                                    size="small"
                                    options={AutoOptions.Safes}
                                    getOptionLabel={(option) =>
                                        typeof option === "string" ? option : option.name
                                    }
                                    style={{}}
                                    disableClearable
                                    renderInput={(params) => (
                                        <TextField
                                            id="valueSafes"
                                            {...params}
                                            label={transForm("safe")}
                                            variant="outlined"
                                            size="small"
                                            InputProps={{ ...params.InputProps, readOnly: true }}
                                            InputLabelProps={{ className: claslbl.clor }}
                                        //  InputLabelProps={{shrink: true}}
                                        />
                                    )}
                                />
                            </Grid>
                            {uiElement.bank == true && (
                                <Grid item lg={1} md={2} sm={2} xs={5}>
                                    <Autocomplete
                                        classes={clasAo}
                                        value={valueStock}
                                        onChange={(event, newValue) => {
                                            changAutoStock(newValue);
                                        }}
                                        id="controllable-states-demo"
                                        size="small"
                                        options={AutoOptions.Stocks}
                                        getOptionLabel={(option) =>
                                            typeof option === "string" ? option : option.name
                                        }
                                        // style={{  }}

                                        disableClearable
                                        disabled={uiElement.stock}
                                        renderInput={(params) => (
                                            <TextField
                                                id="valueStock"
                                                {...params}
                                                label={transForm("account")}
                                                variant="outlined"
                                                size="small"
                                                InputProps={{ ...params.InputProps, readOnly: true }}
                                                InputLabelProps={{ className: claslbl.clor }}
                                            />
                                        )}
                                    />
                                </Grid>
                            )}

                            {uiElement.bank == false && (
                                <Grid item lg={1} md={3} sm={2} xs={4}>
                                    <Autocomplete
                                        classes={clasAo}
                                        value={valueBank}
                                        onChange={(event, newValue) => {
                                            changAutoBank(newValue);
                                        }}
                                        id="controllable-states-demo"
                                        size="small"
                                        options={AutoOptions.Banks}
                                        getOptionLabel={(option) =>
                                            typeof option === "string" ? option : option.name
                                        }
                                        className={clasup.colorSal}
                                        // style={{  }}
                                        disableClearable
                                        disabled={uiElement.bank}
                                        renderInput={(params) => (
                                            <TextField
                                                id="valueBank"
                                                {...params}
                                                label={""}
                                                variant="outlined"
                                                size="small"
                                                InputProps={{ ...params.InputProps, readOnly: true }}
                                                InputLabelProps={{ className: claslbl.clor }}
                                            />
                                        )}
                                    />
                                </Grid>
                            )}


                            <Grid item lg={1} md={1} sm={2} xs={4}>
                                <FormControlLabel
                                    control={
                                        <Tooltip title="التبديل بين شبكة وكاش">
                                            <Grid item lg={1} md={1} sm={2} xs={3}>
                                                <SaleSwitch
                                                    size="small"
                                                    disabled={uiElement.payMethod}
                                                    checked={switchState.cashORnetworksw}
                                                    onChange={changSwitch("cashORnetworksw")}
                                                    id="cashORnetworksw"
                                                    value="cashORnetworksw"
                                                    name="cashORnetworksw"
                                                />
                                            </Grid>
                                        </Tooltip>
                                    }
                                    className={claslbl.clorSw}
                                    label={lbl.chashNetwork}
                                    labelPlacement="start"
                                />
                            </Grid>

                            <Hidden only={["xs"]}>
                                {AutoItem &&
                                    (
                                        <Grid item lg={2} md={2} sm={3} xs={8} style={{ paddingBottom: "0.5rem" }}>
                                            <TextField
                                                inputRef={inputRef}
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                size="small"
                                                id="barcode"
                                                disabled={isHedden}
                                                label={transForm("forms:barcode")}
                                                style={{ backgroundColor: isPurches ? colors.blue[50] : isStock ? colors.blue[50] : colors.green[50] }}
                                                name="barcode"
                                                autoFocus={true}
                                                autoComplete="off"
                                                InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrBlackLblSal }}
                                                onKeyDown={handleKeyDown}
                                                onFocus={handleFocus}
                                                onChange={onChangeData("barcode")} />
                                        </Grid>
                                    )}
                                <Grid item lg={1} md={1} sm={2} xs={3} style={{ paddingBottom: "0.5rem" }}>
                                    <TextField fullWidth variant="outlined" size="small"
                                        id="trans_no"
                                        label={"رقم الوردية"}
                                        className={clasTF.rootSale}
                                        InputProps={{ className: claslbls.clrSale, readOnly: true }}
                                        InputLabelProps={{ className: claslbls.clrSale }}
                                        type="text"
                                        name="trans_no" value={maxShifts}
                                    />
                                </Grid>
                            </Hidden>
                            <Grid item lg={1} md={1} sm={2} xs={3} style={{ paddingBottom: "0.5rem" }}>
                                <TextField fullWidth variant="outlined" size="small"
                                    id="trans_no"
                                    label={"رقم الطلب"}
                                    className={clasTF.rootSale}
                                    InputProps={{ className: claslbls.clrSale, readOnly: true }}
                                    InputLabelProps={{ className: claslbls.clrSale }}
                                    type="text"
                                    name="OrderNo" value={maxOrderNo}
                                />
                            </Grid>
                            <Grid item lg={2} md={3} sm={3} xs={4}>
                                <Autocomplete
                                    classes={clasAo}
                                    value={orderData.select}
                                    onChange={(event, newValue) => {
                                        changeOrderType(newValue);
                                    }}
                                    id="controllable-states-demo"
                                    size="small"
                                    options={selectOrderType}
                                    getOptionLabel={(option) =>
                                        typeof option === "string" ? option : option.label
                                    }
                                    className={clasup.colorSal}
                                    disableClearable
                                    renderInput={(params) => (
                                        <TextField
                                            id="valueBank"
                                            {...params}
                                            label={"نوع الطلب"}
                                            variant="outlined"
                                            size="small"
                                            InputProps={{ ...params.InputProps, readOnly: true }}
                                            InputLabelProps={{ className: claslbl.clor }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Hidden only={["xs"]}>
                                <Grid item lg={3} md={3} sm={4} xs={6} style={{ paddingBottom: "0.5rem" }}>
                                    <TextField fullWidth variant="outlined" size="small"
                                        id="refno"
                                        label={transForm("note")}
                                        className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                        InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrSale }}
                                        inputProps={{ borderColor: "black", className: claslbls.clrBlackLblS }}
                                        type="text"
                                        name="notes"
                                        style={{ maxHeight: "3rem" }}
                                        multiline
                                        value={idata.notes}
                                        onChange={changIdata("notes")}
                                    />
                                </Grid>

                                <Grid item lg={1} md={1} sm={3} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                    <FormControlLabel
                                        id="showPaid"
                                        value="showPaid"
                                        name="showPaid"
                                        className={claslbl.clor}
                                        control={
                                            <SaleCheckbox
                                                checked={showPaid}
                                                onChange={(e) => {
                                                    setShowPaid(e.target.checked);
                                                }}
                                                color="primary"
                                            />
                                        }
                                        label="شاشة الدفع"
                                        labelPlacement="end"
                                    />
                                </Grid>
                            </Hidden>



                            {exsub > 0 ? (
                                <Grid item lg={2} md={2} sm={2} xs={4}>
                                    <div className={clasCAB.wrapperCAB}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="medium"
                                            style={{
                                                ...{
                                                    background: "#ff8080",
                                                    color: "#fff",
                                                    direction: "initial",
                                                },
                                            }}
                                            className={buttonClassnameSavetmp}
                                            disabled={loading.savetmp}
                                            onClick={() => toWhere("savetmp", "e")}
                                            startIcon={<StopIcon />}
                                        >
                                            {transForm("invoice-suspension")}
                                        </Button>
                                        {loading.savetmp && (
                                            <CircularProgress
                                                size={24}
                                                className={clasCAB.buttonProgressCAB}
                                            />
                                        )}
                                    </div>
                                </Grid>
                            ) : null}
                            <Hidden smDown>
                                <>
                                    <Grid item lg={1} md={2} sm={2} xs={2} style={{ paddingBottom: "0.5rem" }}>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            onClick={(event) => setOpenTawla(true)}
                                            style={{
                                                background: colors.green[500],
                                                ...{ paddingLeft: 0, paddingRight: 0, },
                                            }}
                                        >
                                            {"الطاولة" + "  "}
                                        </Button>
                                    </Grid>
                                    {idata?.tawla > 0 &&
                                        <Grid item lg={1} md={2} sm={2} xs={4}>
                                            <TextField
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                size="small"
                                                id="id"
                                                label={"رقم الطاولة"}
                                                className={clasTF.root}
                                                InputProps={{ className: clasTF.input, readOnly: true }}
                                                name="id"
                                                value={idata?.tawla}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>
                                    }
                                </>
                            </Hidden>
                            {permistionInv?.DISC_CODE && isdata.length > 0 &&
                                <Hidden mdDown>
                                    <Grid item lg={2} md={2} sm={2} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                        <TextField fullWidth variant="outlined" size="small"
                                            id="col1"
                                            label={"كود الخصم"}
                                            className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                            InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrSale }}
                                            type="text"
                                            name="Dis_Code"
                                            value={idata.Dis_Code}
                                            onChange={changIdata("Dis_Code")}
                                            InputProps={{
                                                className: claslbl.clrBlackTxt,
                                                onKeyDown: (event) => {
                                                    if (event.key === 'Enter') {
                                                        getCodeDiscount();
                                                    }
                                                },
                                            }}
                                        />
                                    </Grid>
                                </Hidden>
                            }
                            {setting.PrTy_InPr === "11" || setting.PrTy_InPr === "12" ? (
                                <Fragment>
                                    <Grid item lg={2} md={3} sm={4} xs={6}>
                                        <TextField
                                            type="number"
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            id="InvId_Return"
                                            label="رقم المرتجع"
                                            className={clasTF.root}
                                            InputProps={{ className: clasTF.input }}
                                            name="InvId_Return"
                                            value={infoInv.InvId_Return}
                                            onChange={changInvs("InvId_Return")}
                                            placeholder=""
                                        />
                                    </Grid>

                                    <Grid item lg={1} md={1} sm={1} xs={1}>
                                        <Button
                                            variant="outlined"
                                            color="secondary"
                                            fontSize="large"
                                            size="medium"
                                            onClick={handClickInvs}
                                        >
                                            تنزيل
                                        </Button>
                                    </Grid>
                                </Fragment>
                            ) : (
                                <Fragment></Fragment>
                            )}
                        </Grid>
                    </React.Fragment>
                </Container>
            </Typography>
            {/* <CssBaseline /> */}
        </div>
    );
}
